import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";

export default class Validation {
  /**
   * Creates a custom validator ensuring two form fields match
   * @param controlName primary control name to compare
   * @param checkControlName confirmation control name to validate against
   * @return ValidatorFn returning a validation error if values do not match
   */
  static match(controlName: string, checkControlName: string): ValidatorFn {
    return (controls: AbstractControl) => {
      const control = controls.get(controlName) as AbstractControl;
      const checkControl = controls.get(checkControlName) as AbstractControl;
      if (checkControl.errors && !checkControl.errors["matching"]) {
        return null;
      }
      if (control.value !== checkControl.value) {
        controls.get(checkControlName)?.setErrors({ matching: true });
        return { matching: true };
      } else {
        controls.get(checkControlName)?.setErrors(null);
        return null;
      }
    };
  }

  static phoneNumber(phoneNumberControlName: string, countryCodeControlName: string): ValidatorFn {
    return async (controls: AbstractControl) => {
      const phoneNumber = controls.get(phoneNumberControlName) as AbstractControl;
      const countryCode = controls.get(countryCodeControlName) as AbstractControl;
      if (phoneNumber.value && countryCode.value) {
        const lib = await import("google-libphonenumber");
        const phoneNumberUtil = lib.PhoneNumberUtil.getInstance();
        if (phoneNumber.value.trim().length !== 0) {
          try {
            const finalPhoneNumber = phoneNumberUtil.parse("+" + countryCode.value + phoneNumber.value);
            if (!phoneNumberUtil.isValidNumber(finalPhoneNumber)) {
              phoneNumber.setErrors({ phoneNumberInvalid: true });
              return { phoneNumberInvalid: true };
            }
          } catch (error) {
            phoneNumber.setErrors({ phoneNumberInvalid: true });
            return { phoneNumberInvalid: true };
          }
        }
      }
      return null;
    };
  }

  static futureDateValidator(futureDate: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!control.value) {
        return null;
      }

      return control.value > futureDate ? { futureDate: true } : null;
    };
  }
}
